<div class="container">
    <div class="flex-box">
        <div class="box-12">
            <h2>{{ 'Title.abonentTitle' | translate }}</h2>
        </div>
    </div>
    <div class="flex-box">
        <div class="box-12">
            <form (ngSubmit)="onSubmit()" [formGroup]="form">
                <div *ngIf="chooseAbonent">
                    <div *ngFor="let abonent of chooseAbonent">
                        <label>
                    <input type="radio" formControlName="user" [value]="abonent.Items" class="radio-input">
                    <div class="choose-abonent-item">
                    <table >
                        <tr>
                            <td>{{ 'label.choose' | translate }}</td>
                            <td></td>
                        </tr>
                        <tr *ngFor="let item of abonent.Data">
                            <td> {{item[0]}}</td>
                            <td>{{item[1]}}</td>
                        </tr>
                    </table>
                </div>
                </label>
                    </div>
                </div>
                <button>   {{ 'Buttons.continue' | translate }}</button>
            </form>
        </div>
    </div>
</div>
<app-loading *ngIf="showLoading"></app-loading>